export enum ProductTypeFilter {
    All = "All Products",
    Beer = "Beer",
    Kombucha = "Kombucha",
    Cider = "Cider",
    Unverified = "Unverified"
}
